module.exports = __webpack_public_path__ + "static/media/sb_expansion_active_icon.649292cf.svg";